module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 526
// module chunks = 1